import FormControl from "../base/FormControl";

export default class InputTime extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "time";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}